import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Export.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(a, { ref: e, ...t, weights: m }));
r.displayName = "ExportIcon";
const s = r;
export {
  s as Export,
  r as ExportIcon
};
